import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cara-front-new/components/pages/services/SingleShopServiceContent/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cara-front-new/components/structure/GeneralContent/index.tsx");
